import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Vehicle, VehicleGroup } from '@fc-core';

import { SortBy } from '@fc-shared/ui/sort-by/sort-by';

export const setSearchVehicleGroupText = createAction(
  '[CoreVehicleGroup] Set Search Vehicle Group Text',
  props<{ searchText: string }>(),
);

export const setVehicleGroupFilterId = createAction(
  '[CoreVehicleGroup] Set Vehicle Group Filter Id',
  props<{ vehicleGroupFilterId: number }>(),
);

export const selectVehicleGroupId = createAction(
  '[CoreVehicleGroup] Select VehicleGroup Id',
  props<{ id: number }>(),
);
export const loadVehicleGroups = createAction(
  '[CoreVehicleGroup/API] Load VehicleGroups',
);
export const vehicleGroupsError = createAction(
  '[CoreVehicleGroup/API] VehicleGroups Error',
  props<{ error: any }>(),
);
export const getVehicleGroupDefaultColors = createAction(
  '[CoreVehicleGroup/API] Get vehicle default colors',
);
export const getVehicleGroupDefaultColorsSuccess = createAction(
  '[CoreVehicleGroup/API] Get vehicle default colors Success',
  props<{ colors: string[] }>(),
);
export const loadVehicleGroupsSuccess = createAction(
  '[CoreVehicleGroup/API] Load VehicleGroups Success',
  props<{ vehicleGroups: VehicleGroup[] }>(),
);

export const addVehicleGroup = createAction(
  '[CoreVehicleGroup/API] Add VehicleGroup',
  props<{ vehicleGroup: VehicleGroup }>(),
);
export const addVehicleGroupSuccess = createAction(
  '[CoreVehicleGroup/API] Add VehicleGroup Success',
  props<{ vehicleGroup: VehicleGroup }>(),
);

export const updateVehicleGroup = createAction(
  '[CoreVehicleGroup/API] Update VehicleGroup',
  props<{ vehicleGroup: VehicleGroup }>(),
);

export const removeVehicleFromGroup = createAction(
  '[VehicleGroup/API] Remove Vehicle from VehicleGroup',
  props<{ vehicleId: number; groupId: number }>(),
);

export const addVehiclesToGroup = createAction(
  '[VehicleGroup/API] Add Vehicles to VehicleGroup',
  props<{ vehicleIdList: number[]; groupId: number }>(),
);
export const addVehiclesToGroupSuccess = createAction(
  '[VehicleGroup/API] Add Vehicles to VehicleGroup Success',
  props<{ vehicleGroup: VehicleGroup; vehicleIdList: number[] }>(),
);

export const addVehicleToGroup = createAction(
  '[VehicleGroup/API] Add Vehicle from VehicleGroup',
  props<{ vehicleId: number; groupId: number }>(),
);

export const removeVehicleFromGroupSuccess = createAction(
  '[VehicleGroup/API] Remove Vehicle from VehicleGroup Success',
  props<{ vehicleGroup: VehicleGroup; vehicleId: number }>(),
);

export const toggleVehicleInGroups = createAction(
  '[VehicleGroup] Remove Vehicle From Groups',
  props<{ vehicle: number; groupsIds: number[] }>(),
);

export const addVehicleToGroupSuccess = createAction(
  '[VehicleGroup/API] Add Vehicle from VehicleGroup Success',
  props<{ vehicleGroup: VehicleGroup }>(),
);

export const updateVehicleGroupSuccess = createAction(
  '[CoreVehicleGroup/API] Update VehicleGroup Success',
  props<{ vehicleGroup: Update<VehicleGroup> }>(),
);

export const deleteVehicleGroup = createAction(
  '[CoreVehicleGroup/API] Delete VehicleGroup',
  props<{ id: number }>(),
);

export const deleteVehicleGroupSuccess = createAction(
  '[CoreVehicleGroup/API] Delete VehicleGroup Success',
  props<{ id: number }>(),
);

export const updateCreatedVehicleGroup = createAction(
  '[CoreVehicleGroup] Update Created Vehicle Group',
  props<{ vehicle: Vehicle }>(),
);
export const setVehicleGroupSortBy = createAction(
  '[CoreVehicleGroup] Set VehicleGroup Sort By',
  props<{ sortBy: SortBy }>(),
);
export const resetDefaultVehicleGroupFilters = createAction(
  '[CoreVehicleGroup] Reset Default VehicleGroup Filters',
);
